import { useNavigate, useParams } from 'react-router-dom';
import { RegisterMembershipForm } from '../components/register-membership-form';
import { useInviteSuspense } from '@/features/invites/api/get-invite';
import { MembershipRole } from '@/types/api/membership';
import { useRegisterMembership } from '../api/register-membership';
import { paths } from '@/config/paths';
import { InviteStatus } from '@/types/api/invite';
import { InviteInvalid } from '@/features/invites/components/invite-invalid';

export function RegisterMembership() {
  const navigate = useNavigate();
  const code = useParams().code!;
  const { data: invite } = useInviteSuspense({ code });
  const mutation = useRegisterMembership({
    mutationConfig: { onSuccess: () => navigate(paths.membership.registered.getHref(invite.orgId)) },
  });

  const title = invite.roles.includes(MembershipRole.Leader)
    ? `Bli ledare i ${invite.orgName} 💜`
    : `Gå med i ${invite.orgName} 💜`;

  if (invite.status !== InviteStatus.Active) {
    return <InviteInvalid status={invite.status} />;
  }

  return (
    <div className="space-y-4 max-w-sm mx-auto px-4">
      <h2 className="text-xl font-semibold">{title}</h2>
      <RegisterMembershipForm
        defaultValues={{ participate: false, code }}
        roles={invite.roles}
        onSubmit={(data) => mutation.mutateAsync({ data })}
        className="space-y-4"
      />
    </div>
  );
}
